var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBehind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.56227V13.1246C0 13.6078 0.39169 13.9996 0.874979 13.9996H13.1247C13.608 13.9996 13.9997 13.6078 13.9997 13.1246V4.81232H0V6.56227ZM11.6282 5.24981H13.5622V6.56227H11.1356L11.6282 5.24981ZM7.23332 5.24981H9.19725L8.70459 6.56227H6.74059L7.23332 5.24981ZM2.83818 5.24981H4.80211L4.30945 6.56227H2.34552L2.83818 5.24981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9152 9.49977e-06C12.8655 9.49977e-06 12.8152 0.00420865 12.7646 0.0128997L0.723372 2.09467C0.248283 2.1767 -0.0696839 2.62514 0.0132391 3.09582L0.238136 4.37489L13.9998 1.99595L13.7747 0.717183C13.7007 0.296393 13.3318 0 12.9153 0L12.9152 9.49977e-06ZM4.38962 3.21318L2.46026 3.54677L2.71113 2.19486L4.64039 1.86136L4.38962 3.21318ZM8.70801 2.46672L6.77876 2.80022L7.02943 1.4485L8.95878 1.11491L8.70801 2.46672ZM11.0972 2.05373L11.348 0.701817L12.8389 0.444099C12.8643 0.439704 12.8899 0.437458 12.9153 0.437458C13.1274 0.437458 13.3076 0.586967 13.3439 0.792925L13.493 1.63958L11.0972 2.05373Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBehind);
export default __webpack_public_path__ + "static/media/icon-behind.df6352a120a1598f1f126785bf9f8b5e.svg";
export { ForwardRef as ReactComponent };